import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { scroller, Events } from 'react-scroll';
import isEqual from 'lodash/isEqual';
import X from 'wix-ui-icons-common/X';
import NavigationSideBar from '../NavigationSideBar';
import Cart from '../Cart';
import Checkout from '../Checkout';
import MenuViewer from '../MenuViewer';
import styles from './OrderManager.scss';
import { FLOW_STEP } from '../../stateManagement/engine/reducers/SessionReducer';
import PrettyIcon from '../PrettyIcon';
import isEmpty from 'lodash/isEmpty';
import _ from 'lodash';
import { Modals } from '../../utils/constants';

import { isSpecialKeyPressed } from '../../utils/enviormentUtils';
import { Text } from 'wix-style-react';

const SCROLL_TIMING = 400;
const MENU_CONTAINER_ID = 'call-center-order-manager';
const hotKeys = ['F', 'L', 'O', 'ENTER', 'I'];

export default class OrderManager extends React.Component {
  static displayName = 'OrderManager';

  static propTypes = {
    acceptsTip: PropTypes.bool,
    step: PropTypes.string,
    stepData: PropTypes.object,
    simplifiedMenu: PropTypes.object,
    itemsHash: PropTypes.object,
    organization: PropTypes.object,
    lowResMenuShown: PropTypes.bool,
    deliveryType: PropTypes.string,
    query: PropTypes.string,
    filters: PropTypes.object,
    menuQuery: PropTypes.func,
    toggleMenuFilter: PropTypes.func,
    clearFilters: PropTypes.func,
    orderItems: PropTypes.array,
    cartUpsert: PropTypes.func,
    orderItemChangeCount: PropTypes.func,
    sideMenuDisplay: PropTypes.func,
    priceComponents: PropTypes.object,
    displayableDiscounts: PropTypes.array,
    customer: PropTypes.object,
    address: PropTypes.object,
    displayCustomerDetailsSummary: PropTypes.bool,
    toggleCustomerDetailsSummary: PropTypes.func,
    displayModal: PropTypes.func,
    hideModal: PropTypes.func,
    goBack: PropTypes.func,
    closeOrderHistory: PropTypes.func,
    unavailableDishesOkClick: PropTypes.func,
    unavailableDishesCancelClick: PropTypes.func,
    unavailableDishesCloseModal: PropTypes.func,
    orderHistoryDisplayable: PropTypes.array,
    orderHistoryRaw: PropTypes.array,
    mergeExistingOrder: PropTypes.func,
    managerDiscount: PropTypes.object,
    setManagerDiscount: PropTypes.func,
    manualDeliveryFee: PropTypes.object,
    changeOrderComment: PropTypes.func,
  };

  static defaultProps = {
    menuQuery: () => {},
    toggleMenuFilter: () => {},
    clearFilters: () => {},
    sideMenuDisplay: () => {},
    orderItems: [],
    displayableDiscounts: [],
    customer: {},
    address: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      subRoute: [],
      showSideNavigation: props.lowResMenuShown,
      showFilters: false,
      selectedLeaf: '',
      selectedSection: '',
      midNavigation: false,
    };

    this.isNavigating = false;
    this.searchRef = React.createRef();

    this._scrollContainerRef = this._scrollContainerRef.bind(this);
    this._onScroll = this._onScroll.bind(this);
    this._onQueryChange = this._onQueryChange.bind(this);
    this._onFilter = this._onFilter.bind(this);
    this._onDishSelect = this._onDishSelect.bind(this);
    this._onCartDishSelect = this._onCartDishSelect.bind(this);
  }
  allNavigationTargets;

  toggleFiltersButton = () => {
    this.setState(prevState => ({ showFilters: !prevState.showFilters }));
  };

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(prevState.subRoute, this.state.subRoute)) {
      this._navigationtimeout = setTimeout(() => {
        this.isNavigating = false;
      }, SCROLL_TIMING);
    }

    if (this.props.lowResMenuShown !== prevProps.lowResMenuShown) {
      this._slideTimeout = setTimeout(
        () => this.setState({ showSideNavigation: this.props.lowResMenuShown }),
        this.props.lowResMenuShown ? 0 : 3000,
      );
    }
  }

  hotKeysKeyDownListener = e => {
    if (this.props.step !== FLOW_STEP.ORDER) {
      return;
    }
    if (hotKeys.includes(e.key.toUpperCase()) && isSpecialKeyPressed(e)) {
      e.preventDefault();
      if (!e.repeat) {
        this.hotKeysActions[e.key.toUpperCase()]();
      }
    }
  };

  onHotkeyF = () => this.searchRef.current.focus();

  onHotkeyL = () => this.toggleFiltersButton();

  onHotkeyO = () => this._handleCancelOrderClick();

  onHotkeyENTER = () => {
    if (this.props.orderItems.length > 0) {
      this.props.goToCheckout();
    }
  };

  onHotkeyI = () => {
    this._onSummaryTitleClick();
  };

  hotKeysActions = {
    L: this.onHotkeyL,
    O: this.onHotkeyO,
    F: this.onHotkeyF,
    ENTER: this.onHotkeyENTER,
    I: this.onHotkeyI,
  };

  componentDidMount() {
    window.addEventListener('keydown', ev => this.hotKeysKeyDownListener(ev));
    Events.scrollEvent.register('end', () => {
      this.setState({ midNavigation: false });
    });
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.hotKeysKeyDownListener);
    clearTimeout(this._navigationtimeout);
    clearTimeout(this._slideTimeout);
    Events.scrollEvent.remove('end');
  }

  render() {
    const { step } = this.props;
    const mainContent = step === FLOW_STEP.CHECKOUT ? this._getCheckout() : this._getMenu();
    const navigation = this._getNavigation();
    const cart = this._getCart();

    return (
      <div className={styles.wrapper}>
        {navigation}
        {mainContent}
        {cart}
      </div>
    );
  }

  _getNavigation() {
    const { showSideNavigation } = this.state;
    const { lowResMenuShown } = this.props;
    const appendToBody = lowResMenuShown || showSideNavigation;
    const navigation = this._getNavigationComponents(appendToBody);

    return appendToBody ? ReactDOM.createPortal(navigation, document.body) : navigation;
  }

  _onNavigationSideBarSelect = route => {
    this.setState({ midNavigation: true, ...route });
  };

  _getNavigationComponents(appendToBody) {
    const { subRoute, showSideNavigation, selectedSection, selectedLeaf } = this.state;
    const {
      organization,
      simplifiedMenu,
      deliveryType,
      query,
      filters,
      lowResMenuShown,
      address,
      customer,
      displayCustomerDetailsSummary,
      step,
    } = this.props;
    const isShown = lowResMenuShown && showSideNavigation;
    const onOverlayClick = isShown ? this._onCloseNavigation : undefined;
    const organizationAddress = _.get(organization, 'address.formatted');

    return (
      <div
        className={`${styles.overlay} ${isShown ? styles.show : ''}`}
        onClick={onOverlayClick}
        data-hook="order-manager-menu-list"
      >
        <div className={styles.navigation}>
          {appendToBody ? this._getNavigationHeader() : null}
          <div className={styles.navigationContainer}>
            <NavigationSideBar
              onSelect={this._onNavigationSideBarSelect}
              simplifiedMenu={simplifiedMenu}
              route={subRoute}
              selectedLeaf={selectedLeaf}
              selectedSection={selectedSection}
              locale={organization.locale}
              deliveryType={deliveryType}
              timezone={organization.timezone}
              query={query}
              filters={filters}
              address={address}
              customer={customer}
              showSummary={displayCustomerDetailsSummary}
              onSummaryTitleClick={this._onSummaryTitleClick}
              onCustomerInfoClick={this._onCustomerInfoClick}
              onAddressDetailsClick={this._onAddressDetailsClick}
              onOrderHistoryClick={this._onOrderHistoryClick}
              shouldDisplayOrderHistory={this.props.orderHistoryRaw.length > 0}
              organizationAddress={organizationAddress}
              step={step}
              organization={organization}
            />
          </div>
        </div>
      </div>
    );
  }

  _getNavigationHeader() {
    return (
      <div className={styles.navigationHeader}>
        <Text size="medium" weight="normal" secondary>
          Menus
        </Text>
        <PrettyIcon className={styles.navigationHeaderClose} onClick={this._onCloseNavigation}>
          <X />
        </PrettyIcon>
      </div>
    );
  }

  _getMenu() {
    const { subRoute, scrollTop, showFilters } = this.state;
    const { organization, filters, clearFilters, deliveryType, simplifiedMenu, query } = this.props;
    const menusHeight = this._scrollContainer ? this._scrollContainer.offsetHeight : 0;

    return (
      <div
         className={styles.menu}
        id={MENU_CONTAINER_ID}
        ref={this._scrollContainerRef}
        data-hook="order-manager-main-container"
      >
        <MenuViewer
          searchRef={this.searchRef}
          showFilters={showFilters}
          toggleFilters={this.toggleFiltersButton}
          onScroll={this._onScroll}
          height={menusHeight}
          simplifiedMenu={simplifiedMenu}
          locale={organization.locale}
          deliveryType={deliveryType}
          timezone={organization.timezone}
          currency={organization.currency}
          query={query}
          filters={filters}
          onQueryChange={this._onQueryChange}
          onFilter={this._onFilter}
          onClearFilters={clearFilters}
          onDishSelect={this._onDishSelect}
          isScrolled={false}
          isScrolled={scrollTop > 0}
          subRoute={subRoute}
          organizationId={organization.id}
        />
      </div>
    );
  }

  _getCheckout() {
    const { organization } = this.props;

    return (
      <div className={styles.checkout} data-hook="order-manager-checkout-container">
        <Checkout locale={organization.locale} currency={organization.currency} />
      </div>
    );
  }

  _getCart() {
    const {
      organization,
      orderItems,
      itemsHash,
      orderItemChangeCount,
      priceComponents,
      displayableDiscounts,
      goToCheckout,
      managerDiscount,
      setManagerDiscount,
      acceptsTip,
      onChangeDeliveryFee,
      allowsManagerDiscount,
      deliveryType,
      step,
      changeOrderComment,
    } = this.props;
    return (
      <div className={styles.cart} data-hook="order-manager-cart">
        <Cart
          allowsManagerDiscount={allowsManagerDiscount}
          acceptsTip={acceptsTip}
          orderItems={orderItems}
          itemsHash={itemsHash}
          locale={organization.locale}
          currency={organization.currency}
          discounts={displayableDiscounts}
          onOrderItemCountChange={orderItemChangeCount}
          onGoToCheckout={goToCheckout}
          priceComponents={priceComponents}
          onDishSelect={this._onCartDishSelect}
          discountInputValue={managerDiscount.amount}
          onManagerDiscountChange={setManagerDiscount}
          onChangeDeliveryFee={onChangeDeliveryFee}
          deliveryType={deliveryType}
          displayGoToCheckout={step !== FLOW_STEP.CHECKOUT}
          displayPlaceOrder={step === FLOW_STEP.CHECKOUT}
          onChangeSpecialRequest={changeOrderComment}
          onCancelOrderClick={this._handleCancelOrderClick}
        />
      </div>
    );
  }

  _scrollContainerRef(el) {
    this._scrollContainer = el;
  }

  _onScroll(args) {
    const isTheCurrentActiveNavigationTarget = (navigationTarget, yPosition) => {
      const navigationTargetOffset = navigationTarget.offsetTop;
      const navigationTargetTopOffset = yPosition - navigationTargetOffset;

      return (
        navigationTargetTopOffset > -40 &&
        navigationTargetTopOffset < navigationTargetOffset + navigationTarget.offsetHeight
      );
    };
    const scrollContainer = args.currentTarget;

    const { subRoute } = this.state;
    const { query, filters } = this.props;
    const isFiltered = query || !isEmpty(filters);
    if (this._scrollContainer && !isFiltered) {
      this.allNavigationTargets = this.allNavigationTargets
        ? this.allNavigationTargets
        : this._scrollContainer.querySelectorAll('[data-scroll="section-scroll"]');
      const header = this._scrollContainer.querySelector('[data-hook="menu-viewer-header"]');
      const scrollTop = scrollContainer.scrollTop;
      const yPosition = scrollTop + (header ? header.offsetHeight : 0);
      let top = '';
      let parent = null;

      this.setState({ scrollTop });
      for (let i = 0; i < this.allNavigationTargets.length; i++) {
        const navigationTarget = this.allNavigationTargets[i];

        if (isTheCurrentActiveNavigationTarget(navigationTarget, yPosition)) {
          const isMenuTitle = navigationTarget.getAttribute('data-menu');

          if (!isMenuTitle) {
            top = navigationTarget.getAttribute('name');
            parent = navigationTarget.parentElement.closest('[data-hook="menu-section"]').getAttribute('name');
          } else {
            parent = navigationTarget.getAttribute('data-name');
            top = navigationTarget.parentElement.querySelector('[data-hook="section-title"]').getAttribute('name');
          }
        }
      }

      if (!this.isNavigating && parent && top && (!subRoute || subRoute.length < 2 || subRoute[1] !== top)) {
        const [selectedLeaf, selectedSection] = [top, parent];
        if (!this.state.midNavigation) {
          this.setState({ selectedLeaf, selectedSection });
        }
      }
    }
  }

  _onQueryChange = query => {
    const { menuQuery } = this.props;
    menuQuery({ query });
  };

  _onFilter = filter => {
    const { toggleMenuFilter } = this.props;
    toggleMenuFilter({ filter });
  };

  _onDishSelect = item => {
    const { editDishNew } = this.props;
    editDishNew({ itemId: item.id, availability: item.condition.availability });
  };

  _onCartDishSelect = ({ cartIndex }) => {
    const { editDishStartEditing, orderItems } = this.props;
    editDishStartEditing({ orderItem: orderItems[cartIndex], cartIndex, origin: 'cart' });
  };

  _onCloseNavigation = () => {
    const { sideMenuDisplay } = this.props;
    sideMenuDisplay({ value: false });
  };

  _onSummaryTitleClick = () => {
    const { toggleCustomerDetailsSummary } = this.props;
    toggleCustomerDetailsSummary();
  };

  _onCustomerInfoClick = () => {
    const { displayModal } = this.props;
    displayModal({ modal: Modals.CUSTOMER_INFORMATION });
  };

  _onAddressDetailsClick = () => {
    const { displayModal } = this.props;
    displayModal({ modal: Modals.ADDRESS_INFORMATION });
  };

  _onOrderHistoryClick = () => {
    const { displayModal } = this.props;
    displayModal({ modal: Modals.ORDER_HISTORY });
  };

  _goBack = () => {
    const { goBack } = this.props;
    goBack();
  };

  _handleCancelOrderClick = () => {
    const { displayModal } = this.props;
    displayModal({ modal: Modals.CANCEL_ORDER });
  };
}
